'use strict';

/**
 * Normalize Strapi slug values for routing and GraphQL lookups.
 * Trims leading/trailing whitespace and removes whitespace elsewhere in the slug.
 *
 * @param {string|null|undefined} slug
 * @returns {string}
 */
function normalizeSlug(slug) {
  if (slug == null || slug === '') return '';
  return String(slug).trim().replace(/\s+/g, '');
}

module.exports = { normalizeSlug };
